<template>
<div class="searchHeader">
    <div class="borderLine borderTop title color333 yahei">
        <div>
            <span class="mr10">拍品筛选</span>
            <el-select style="width: 78px;" v-model="searchList.startdate" clearable size="small" @change="changeYear">
                <el-option
                    v-for="item in dateList"
                    :key="item.session_id"
                    :label="item.year+'年'"
                    :value="item.year">
                </el-option>
            </el-select>
            <el-select style="width: 78px;" v-model="searchList.specialCode" clearable size="small"  v-if="specialShow">
                <el-option
                    v-for="item in sessionList"
                    :key="item.specialCode"
                    :label="item.name"
                    :value="item.specialCode">
                </el-option>
            </el-select>
        </div>

        <div class="col fl">
            <div id="rank-priceform" class="price click">
                <div class="fm-price">
                    <p class="fix" style="display: flex; align-items: center;">
                        <input v-model="searchList.originalEvaluation" type="text" id="highprice" title="按价格区间筛选 最低价" name="end_price" class="txt" placeholder="￥" onkeyup="this.value=this.value.replace(/[^0-9.]/g,'') ">
                        <span class="fl spanA" style="margin-left: 5px;"> -</span>
                        <input v-model="searchList.lastEvaluation" type="text" id="lowprice" title="按价格区间筛选 最高价" name="start_price" class="txt" placeholder="￥" onkeyup="this.value=this.value.replace(/[^0-9.]/g,'') ">
                    </p>
                    <!-- <div class="btns fix">
                        <span class="btn fr">确定</span>
                        <span class="btn fl">清除</span>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="searchBox">
            <el-input v-model="searchList.keyword" size="small">
                <template slot="append">
                    <span style="cursor: pointer;" @click="searchHandleClick">搜索</span>
                </template>
            </el-input>
        </div>
    </div>
</div>
</template>

<script>
import { postDate } from '@/api/company'
import {getProSession} from "@/api/product/detail";

export default {
    name: "searchHeader",
    props:['organId'],
    data() {
        return {
            dateList: [],
            sessionList:[],
            searchList: {
                startdate:'',
                enddate: '',
                keyword: this.$route.query.keyword ? decodeURIComponent(this.$route.query.keyword) : '',
                originalEvaluation: '',
                lastEvaluation: '',
                specialCode:'',
            },
            specialShow:false
        }
    },
    watch:{
        'organId':function (newValue){
            this.postDates(newValue)
        }
    },
    methods: {
        searchHandleClick() {
            this.$emit('searchHandleClick', this.searchList)
        },
        postDates(id) {
            postDate({
                organ_code: id
            }).then(res => {
                this.dateList = res.data.list
            })
        },
        changeYear(val){
            let parmas = {
                order:1,
                page_size:1000,
                status:5,
                organ_code:this.organId,
                page:1,
                is_total:1,
                start_time:val + '-01-01',
                end_time:val + '-12-31'
            }
            getProSession(parmas).then((res) => {
                if(res.code == 0){
                    this.specialShow = true
                    let data = res.data.list
                    this.sessionList = data;
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.searchHeader{

    .title{
        height: 48px;
        line-height: 48px;
        padding-left: 19px;
        font-size: 14px;
        display: inline-flex;
        width: 100%;
    }
    .col {
        position: relative;
        .price {
            float: left;
            height: 25px;
            position: relative;
            width: 180px;
            .fm-price
            {
                p {
                    word-wrap: break-word;
                    white-space: nowrap;
                    width: 180px;
                    input {
                        margin: 0px 0 0 8px;
                        height: 32px;
                        width: 70px;
                        border-radius: 5px;
                    }
                }
            }
        }
        input.txt {
            padding: 4px;
            border: 1px solid #e6e6e6;
            width: 50px;
            height: 15px;
            color: #333;
        }
    }
    /deep/.el-input--suffix .el-input__inner{
        padding-left: 10px;
        padding-right: 20px;
    }
    /deep/.el-input__suffix{
        right: 0;
    }
}
</style>